import { useMutation } from "react-query";
import { startOfflineSync } from "../../../services/offlineMode";

export const useOfflineModeMutation = () => {
  return useMutation(() => startOfflineSync());
};
